<template>
  <div
    :data-test="headlineName"
    :data-headline-id="id"
  >
    <h5
      class="mt-3 d-flex align-items-center"
    >
      <span
        class="small mx-2"
        :data-test="'display_' + title"
      >{{ title }}</span>
    </h5>
  </div>
</template>

<script>

export default {
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    node: {
      type: Object,
      required: false,
    },
  },
  computed: {
    headlineName () {
      return (this.title && this.title.split(' ').join('-')) || ''
    },
  },
}
</script>
